export default __webpack_public_path__ + "static/media/browns_white.7f5360ff.png";